import React, { useContext, useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import classNames from "classnames";
import { AppContext } from "../../AppContext";
import { Edit, Lock, LockOpenSharp } from "@mui/icons-material";
import useLocalStorage from "use-local-storage";
import "./Header.css";

const Header = () => {
  const { appState, setAppState } = useContext(AppContext);
  const { header, editMode } = appState;
  const [myStore, setMyStore] = useLocalStorage("name", {});
  const history = useHistory();

  const [searchOpen, setSearchOpen] = useState(false);
  const [navOpen, setNavOpen] = useState(false);

  const toggleNav = () => setNavOpen(!navOpen);
  const toggleSearch = () => setSearchOpen(!searchOpen);

  const triggerChild = (e) => {
    e.currentTarget.classList.toggle("open");
  };

  if (!header?.socialLinks) return null;

  return (
    <header className="header-style-1" style={{ zIndex: 1000 }}>
      {/* Topbar */}
      {navOpen && <div className="topbar-style-1" style={{
        backgroundColor: '#27346a'
      }}>
        <div className="container" >
          <div className="row justify-content-center">
            <div className="col-lg-6 col-md-6 col-12"

            >
              <div className="left-side">
                <div className="language-box">
                  <div className="language p-relative">
                    {header?.img && (
                      <img
                        src={header?.img}
                        alt="flag"
                        style={{ maxHeight: 30 }}
                      />
                    )}
                    <select>
                      {header?.languages.map((lang, idx) => (
                        <option key={idx}>{lang?.label}</option>
                      ))}
                    </select>
                  </div>
                </div>
                {/* <h6 className="text-custom-white no-margin">{header?.company || 'HERITAGE HUB FEDERAL CREDIT UNION'}</h6> */}
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12">
              <div className="right-side" style={{ marginTop: 20 }}>
                <ul className="custom">
                  {header.socialLinks.map((item, i) => (
                    <li key={i}>
                      <Link
                        onClick={() => window.open(item.url, "_self")}
                        className="text-custom-white"
                        style={{ fontSize: 'clamp(12px, 1vw, 18px)' }}
                      >
                        <i className={item.icon} />
                      </Link>
                    </li>
                  ))}
                  <li className="search">
                    <Link
                      to="#"
                      className="text-custom-white"
                      style={{ fontSize: 'clamp(12px, 1vw, 18px)' }}
                      onClick={toggleSearch}
                    >
                      <i className={classNames("fas fa-search", { "fa-times": searchOpen })} />
                    </Link>
                  </li>
                  <li className={classNames("topbar-search", { "search-visible": searchOpen })}>
                    <form>
                      <input type="search" className="form-control" placeholder="Search..." />
                    </form>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>}

      {/* Navigation */}
      <div className="main-navigation-style-1 sticky" style={{ position: 'relative', zIndex: 1000 }}>
        <div className="container">
          <div className="navigation">
            {/* Logo */}
            <div className="logo" style={{
              // height: 50,
              flexDirection: 'row',
              display: 'flex',
            }}>
              <Link to="/" >
                <img
                  src={header.img}
                  alt="logo"
                  style={{
                    width: header?.width
                      ? Number(header?.width)
                      : 50
                  }}
                />
              </Link>
            </div>

            <h6 style={{
              marginTop: 30,
              marginLeft: -100
            }}>
              {header.company || 'HERITAGE HUB FEDERAL CREDIT'}
            </h6>

            {/* Menu */}
            <div className={classNames("main-menu", { active: navOpen })}>
              <div className="mobile-logo">
                <Link to="/">
                  <img src={header.logo} alt="logo" />
                </Link>
              </div>
              <nav>
                <ul
                  className="custom"
                  style={{
                    display: 'flex',
                    flexWrap: 'nowrap',
                    overflowX: 'auto',
                    whiteSpace: 'nowrap',
                    gap: '1rem',
                  }}
                >
                  {/* {myStore?.myInfo?.token && (
                    <li className="menu-item">
                      <Link
                        to="/"
                        onClick={() => setAppState(prev => ({ ...prev, editMode: !editMode }))}
                        style={{ fontSize: 'clamp(12px, 1vw, 18px)', color: 'lightblue' }}
                      >
                        Edit
                      </Link>
                    </li>
                  )} */}
                  {header?.navigationmenu.map((item, i) => (
                    <li
                      key={i}
                      className={classNames("menu-item", { "menu-item-has-children": item.child })}
                      style={{ position: 'relative' }}
                      onClick={triggerChild}
                    >
                      <Link
                        to="#"
                        onClick={(e) => {
                          e.preventDefault();
                          window.open(item.link, "_self");
                        }}
                        style={{ fontSize: 'clamp(12px, 1vw, 18px)' }}
                        className="text-custom-white"
                      >
                        {item.linkText}
                      </Link>

                      {/* Submenu */}
                      {item.child && (
                        <ul
                          className="sub-menu"
                          style={{
                            position: "absolute",
                            top: "100%",
                            left: 0,
                            backgroundColor: "#fff",
                            padding: "10px",
                            boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                            zIndex: 1050,
                            minWidth: 180,
                          }}
                        >
                          {item.submenu.map((sub_item, j) => (
                            <li key={j} className="menu-item">
                              <Link
                                to="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  window.open(sub_item.link, "_self");
                                }}
                                className="text-light-grey"
                                style={{ fontSize: 'clamp(12px, 1vw, 18px)' }}
                              >
                                {sub_item.linkText}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      )}
                    </li>
                  ))}
                </ul>
              </nav>

              {/* Auth Button */}
              <div className="right-side" style={{ display: "flex", alignItems: "center" }}>
                <Link
                  to={myStore?.myInfo?.token ? "/logout" : "/login"}
                  onClick={() => {
                    if (myStore?.myInfo?.token) {
                      const confirmed = window.confirm("Logout?");
                      if (confirmed) setMyStore({});
                    } else {
                      history.push("/login");
                    }
                  }}
                  className="cta-btn"
                  style={{ height: "20px", width: "20px" }}
                >
                  {myStore?.myInfo?.token ? <LockOpenSharp /> : <Lock />}
                </Link>
                {myStore?.myInfo?.token && (
                  <li className="menu-item">
                    <Link
                      to="/"
                      onClick={() => setAppState(prev => ({ ...prev, editMode: !editMode }))}
                      style={{ fontSize: 'clamp(12px, 1vw, 18px)', color: 'lightblue' }}
                    >
                      <Edit style={{
                        color: editMode ? 'red' : ''
                      }} />
                    </Link>
                  </li>
                )}
              </div>
            </div>

            {/* Hamburger */}
            <div className="hamburger-menu">
              <div className={classNames("menu-btn", { active: navOpen })} onClick={toggleNav}>
                <span />
                <span />
                <span />
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
